/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_cloud_logic_custom": [
        {
            "name": "ExamSparkAppRestApiV1",
            "endpoint": "https://znh368wl84.execute-api.us-east-1.amazonaws.com/master",
            "region": "us-east-1"
        }
    ],
    "aws_appsync_graphqlEndpoint": "https://gozyt34eqvg77oxvwhv6beoxqu.appsync-api.us-east-1.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_appsync_apiKey": "da2-tdtnvaavknbfnlhzztpnokiska",
    "aws_cognito_identity_pool_id": "us-east-1:7a3bc93c-e286-4157-9624-d5566cea7da5",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_HSoTatlTZ",
    "aws_user_pools_web_client_id": "72luk71ks5rjfi1r22219jgslp",
    "oauth": {
        "domain": "examspark-master.auth.us-east-1.amazoncognito.com",
        "scope": [
            "phone",
            "email",
            "openid",
            "profile",
            "aws.cognito.signin.user.admin"
        ],
        "redirectSignIn": "http://localhost/authenticate/",
        "redirectSignOut": "http://localhost/logout/",
        "responseType": "code"
    },
    "federationTarget": "COGNITO_USER_AND_IDENTITY_POOLS",
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "examspark-app-files-master",
    "aws_user_files_s3_bucket_region": "us-east-1"
};


export default awsmobile;
